import React, { useState } from "react";
import { useSelector } from 'react-redux'
import { Form, Input, Button, message, Row, Col } from "antd";
import { motion } from "framer-motion";
import styles from './OtherPages.module.css';
import { useLocation, Link } from "react-router-dom";
import { getTranslation } from "../../util/utilFunc";
import { getErrorMessage } from "../../util/GetError";
import AuthService from "../../services/authServices";
import { FiCheckCircle } from "react-icons/fi";

const PasswordResetForm = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token"); // extract token from URL

  const [form] = Form.useForm();
  const { language } = useSelector((state) => state.auth);

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.warning(getTranslation("Passwords do not match!", language));
      return;
    }

    setLoading(true);
    try {
      const data = { token, newPassword: values.newPassword };
      const response = await AuthService.resetPassword(data); // Placeholder AuthService
      if (response.data) {
        message.success(getTranslation("Password reset successfully!", language));
        setSubmitted(true);
      }
    } catch (error) {
      message.error(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.bg__primary}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ boxShadow: '0 0.344px 6px gray' }}
        className={styles.contact__form}
      >
        {!submitted ? (
          <>
            <h2>{getTranslation("Reset Your Password", language)}</h2>
            <p>{getTranslation("Please enter your new password below.", language)}</p>
            <Form layout="vertical" onFinish={onFinish} form={form}>
              <Row gutter={16}>
                <Col xs={24}>
                  <Form.Item
                    label={getTranslation("New Password", language)}
                    name="newPassword"
                    rules={[{ required: true, message: getTranslation("Please enter your new password", language) }]}
                  >
                    <Input.Password placeholder={getTranslation("New Password", language)} />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    label={getTranslation("Confirm Password", language)}
                    name="confirmPassword"
                    rules={[{ required: true, message: getTranslation("Please confirm your password", language) }]}
                  >
                    <Input.Password placeholder={getTranslation("Confirm New Password", language)} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                  {getTranslation("Reset Password", language)}
                </Button>
              </Form.Item>
            </Form>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: 20 }}>
            <div>
              <FiCheckCircle style={{ fontSize: "5rem", color: "#52c41a" }} />
            </div>
            <h3>{getTranslation("Password reset successful!", language)}</h3>
            <p>{getTranslation("Please login with your new password.", language)}</p>
            <Link to="/login" className="primaryBtn">{getTranslation("Login", language)}</Link>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default PasswordResetForm;
